// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"f8b1926d","377":"d4fb0a9a","886":"b16d3928","970":"317d5081"}[chunkId] + ".chunk.js";
};